<template>
	<div class="corpo">
		<!-- ---- DESTAQUES ----  #FF0000-->
		<button
		@click="onClick('destaques')"
		:to="{ name: 'carrinho' }"
    :class="selecionado == 'destaques' ? 'fundo-selecionado' : '' "
		class="btn-expand"
		>
		<div>
			<img
			:style="{
				filter: selecionado == 'destaques' ? '' : corImagem,
			}"
			src="../../assets/icons/ic_star.svg"
			alt=""
			class="ic-carrinho"
			/>
		</div>
		<p :class="selecionado == 'destaques' ? '':'texto-menu-baixo'"
    >DESTAQUES</p>
		</button>
		<!-- ---- CARDAPIO ----  -->
		<button
		@click="onClick('cardapio')"
		:to="{ name: 'carrinho' }"
    :class="selecionado == 'cardapio' ? 'fundo-selecionado' : '' "
		class="btn-expand btn-barras"
		>
		<div>
			<img
			:style="{
				filter: selecionado == 'cardapio' ? '' : corImagem,
			}"
			src="../../assets/icons/ic_menu.svg"
			alt=""
			class="ic-carrinho"
			/>
		</div>
		<p :class="selecionado == 'cardapio' ? '':'texto-menu-baixo'">CARDÁPIO</p>
		</button>
		<!-- ---- CARRINHO DE COMPRAS ----  -->
		<!-- <router-link v-if="!this.$store.state.isMenuEstatico" @click="onClick('carrinho')"  :to="{ name: 'carrinho' }" :style="selecionado == 'carrinho' ? 'background: var(--cor2)' : ''"  :class="[numeroItens != 0 ? 'btn-expand btn-expand-animar' : 'btn-expand']"> -->

      <!-- :style="selecionado == 'carrinho' ? 'background: var(--cor2)' :numeroItens?'':''" -->
		<button
		@click="onClick('carrinho')"
		:to="{ name: 'carrinho' }"
    :class="selecionado == 'carrinho' ? 'fundo-selecionado' : ''"
		class="btn-expand btn-barras"
		v-if="!this.$store.state.isMenuEstatico"
		>
		<div>
			<div v-if="numeroItens != 0" class="numero">
			<div>{{ numeroItens }}</div>
			</div>
			<img
			:style="{filter: selecionado == 'carrinho' ? '' : corImagem}"
			src="../../assets/icons/ic-carrinho.svg"
			alt=""
			:class="[numeroItens != 0 ? 'ic-carrinho-animar' : 'ic-carrinho']"
			/>
		</div>
		<p :class="selecionado == 'carrinho' ? '':'texto-menu-baixo'">CARRINHO</p>
		</button>
		<!-- </router-link> -->
	</div>
</template>

<script>
import { exibirAlertCasaFechada } from "@/utils/AlertaCasaFechada";
import { mapGetters } from "vuex";
export default {
  name: "MenuBaixo",
  props: {
    onClickDestaques: Function,
    onClickCardapio: Function,
    onClickCarrinho: Function,
  },
  data() {
    return {
      mesa: Number,
      numeroItensCarrinho: this.$store.state.itensCarrinho.length,
      corImagem:this.$store.state.corTexto === 'black'? 'invert(0%)' : 'invert(100%)',
    };
  },
  computed: {
    ...mapGetters({
      casaAberta: "getCasaAberta",
    }),
    selecionado() {
      return this.$store.state.abaSelecionada;
    },
    numeroMesa() {
      return this.$store.state.mesa;
    },
    numeroItens() {
      let carrinho = this.$store.state.itensCarrinho;
      let qtd = 0;
      for (let item of carrinho) {
        qtd = qtd + item.quantidade;
      }
      return qtd;
    },
  },
  methods: {
    
    onClick(botao) {
      // a barra de busca desaparece
      this.$store.dispatch("setMostrarBarraBusca", false);

      // a classe selecionada volta a ser a primeira classe de intens
      this.$store.dispatch("selecionarClasseInicial");

      // vai para a aba correta
      switch (botao) {
        case "destaques":
          this.$store.dispatch("setAbaSelecionada", "destaques");
          break;

        case "cardapio":
          this.$store.dispatch("setAbaSelecionada", "cardapio");
          break;

        case "carrinho":
          console.log("vamos ver aqui: ", this.casaAberta);
          if (this.casaAberta == false) {
            exibirAlertCasaFechada();
          } else {
            this.$store.dispatch("setAbaSelecionada", "carrinho");
          }
          break;

        default:
          break;
      }
    },
  },
};
</script>

<style scoped>
.btn-barras {
  /* margin-inline: 2px; */
}

.numero {
  position: absolute;
  margin: 0;
  padding: 0;
  z-index: 5;
  font-size: 12px;
  background: var(--verde-claro);
  border: 1px var(--valor-verde) solid;
  color: white;
  border-radius: 20px;
  transform: translateX(-10px) translateY(-10px);
  width: 20px;
  height: 20px;
}

.numero div {
  position: relative;
  top: 50%;
  transform: translateY(-50%);
}

.icone {
  height: 30px;
  filter: invert(100%);
}

.corpo {
  background: var("--cor-texto");
  height: var(--altura-menu-padrao);
  width: 100%;
  display: flex;
}

.corpo p {
  font-size: 12px;
}

.btn-expand {
  color: white;
  height: 100%;
  display: flex;
  justify-content: space-evenly;
  text-decoration: none;
  align-content: center;
  align-items: center;
  background: var(--gradiente-btn-conta);
  padding-inline: 5px;
  flex-grow: 1;
}
.btn-expand-animar {
  animation: btn-anim 5s infinite;
}
@keyframes btn-anim {
  0% {
    background: var(--gradiente-verde);
  }
  50% {
    background: var(--gradiente-verde);
  }
  100% {
    background: var(--gradiente-verde);
  }
}
.fundo-selecionado{
  background: linear-gradient(to top, var(--cor2-escura), var(--cor2-clara));   
}
.btn-expand img {
  /* padding-inline: 15px; */
  margin: 0;
  text-align: start;
}
.ic-carrinho {
  height: 20px;
  filter: invert(100%);
}
.ic-carrinho-animar {
  height: 20px;
  filter: invert(100%);
  animation: animCarrinhoIcon 0.8s linear;
}
@keyframes animCarrinhoIcon {
  0% {
    transform: rotateZ(0deg);
  }
  50% {
    transform: rotateZ(10deg);
  }
  100% {
    transform: rotateZ(0deg);
  }
}
.texto-menu-baixo{
  color: var(--cor-texto);
}
</style>
